import { Component, OnInit, ViewChild } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UnidadesConsumoService } from '../../../services/unidades-consumo.service';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { PedidosService } from '../../../services/pedidos.service';
import swal from 'sweetalert2';
import { StatusPedido } from '../../../model/statusPedido';

@Component({
  selector: 'app-modal-unidades-consumo-vinculados',
  templateUrl: './modal-unidades-consumo-vinculados.component.html',
  styleUrls: ['./modal-unidades-consumo-vinculados.component.css']
})
export class ModalUnidadesConsumoVinculadosComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal;
  pedidos: any[];
  unidadeConsumo: any;
  pedidoStatus = StatusPedido.listar();

  constructor(
    private unidadesConsumoService: UnidadesConsumoService,
    private pedidosService: PedidosService,
  ) {
    super();
  }

  ngOnInit() {
    this.pedidos = this.prop.pedidos;
    this.unidadeConsumo = this.prop.unidadeConsumo;
  }

  show() {
    this.modal.show();
  }

  async removerVinculos() {
    try {
      this.loading['delete'] = true;
      await lastValueFrom(this.pedidosService.removerVinculos(this.unidadeConsumo.id));
      await lastValueFrom(this.unidadesConsumoService.delete(this.unidadeConsumo.id));
      swal('Unidade de consumo removida com sucesso!', '', 'success');
      this.fechar(true);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['delete'] = false;
    }
  }

  fechar(removeu = false) {
    this.closed.emit(removeu);
  }

  getPedidoStatus(status) {
    return this.pedidoStatus.find(x => x.id === status).descricao;
  }
}
